 /* -------------------------------
    -----   Infinite loading   -----
    --------------------------------*/

    var $infiniteLink = $('#infinite-link'),
        $infiniteURL = $infiniteLink.children('a'),
        $blogList = $('.blog-articles');

    if ($infiniteLink.length > 0) {
      $infiniteURL.on('click', function(e) {
        $infiniteURL.addClass('btn--disabled').text('Loading ...');
        var href = $(this).attr('href');
        $.ajax({
          url: href,
          success: function(data) {
            var $data = $(data),
                $posts = $data.find('div.article'),
                $infinite = $data.find('#infinite-link');
            $posts.imagesLoaded(function() {
              $posts.css('display', 'none');
              $blogList.append($posts);
              $posts.slideDown(300);
              if ($infinite.length > 0) {
                $infiniteURL.removeClass('btn--disabled')
                  .text('More posts')
                  .prop('href', $infinite.children('a').prop('href'));
              } else {
                $infiniteURL.text('All posts loaded');
              }
            });
          }
        });
        e.preventDefault();
      });
    }


 // /* -------------------------------
 //    -----   Iframes   -----
 //    --------------------------------*/

 //    $('.video-overlay').magnificPopup({
 //      type: 'iframe',
 //      mainClass: 'mfp-fade'
 //    });

 //    $('.image-popup').magnificPopup({
 //      type: 'image',
 //      gallery: {
 //        enabled: true,
 //        tCounter: ''
 //      },
 //      mainClass: 'mfp-fade'
 //    });
